import { useEffect, useState, Fragment } from "react";
// @mui
import {
  Button,
  MenuItem,
  Container,
  Grid,
  Typography,
  InputLabel,
  FormControl,
  Box,
  TextField,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Avatar,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Select from "@mui/material/Select";
import axios from "axios";
import moment from "moment";
import { tooltipClasses } from "@mui/material/Tooltip";
import { useNavigate, useSearchParams } from "react-router-dom";
import Iconify from "../iconify";
import AssetsDialog from "./AssetsDialog";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
// ----------------------------------------------------------------------

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1, paddingTop: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const InputTooltip = ({ imgPath }) => (
  <HtmlTooltip
    title={
      <Fragment>
        <img src={imgPath} alt="login" />
      </Fragment>
    }
  >
    <Iconify icon="eva:info-outline" sx={{}} />
  </HtmlTooltip>
);
const dateFormat = "YYYY-MM-DD HH:mm:ss";
const defaultState = {
  title: "",
  start: moment().format(dateFormat),
  end: moment().format(dateFormat),
  is_visible: false,
  prize_image_en: null,
  tournament_type: "WEEK",
};
export default function LeagueTournamentDialog(props) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [tournament, setTournament] = useState(defaultState);
  const [question, setQuestion] = useState(null);
  const [tournamentStart, setTournamentStart] = useState(moment());
  const [tournamentEnd, setTournamentEnd] = useState(moment());
  const [assetsTarget, setAssetsTarget] = useState(null);

  useEffect(() => {
    if (props.tournament !== null) {
      setTournament(props.tournament);
      setTournamentStart(moment(props.tournament.start_time));
      setTournamentEnd(moment(props.tournament.end_time));
    }
  }, [props]);
  const handleChange = (e) => {
    const { id, value } = e.target;

    setTournament((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleChangeIsVisible = (e) => {
    setTournament((prevState) => ({
      ...prevState,
      is_visible: e.target.checked,
    }));
  };
  const handleTournamentStartChange = (newValue) => {
    setTournamentStart(newValue);
    setTournament((prevState) => ({
      ...prevState,
      start_time: moment(newValue).format(dateFormat), //2022-11-23 23:00:00
    }));
  };
  const handleTournamentEndChange = (newValue) => {
    setTournamentEnd(newValue);
    setTournament((prevState) => ({
      ...prevState,
      end_time: moment(newValue).format(dateFormat), //2022-11-23 23:00:00
    }));
  };
  const onSuccess = () => {
    setTournament(defaultState);
    props.onSuccessHandler(tournament);
  };
  const onCancel = () => {
    setTournament(defaultState);
    props.onClose();
  };
  const onChoseAsset = (assetUrl) => {
    setTournament((prevState) => ({
      ...prevState,
      [assetsTarget]: assetUrl,
    }));
    setAssetsTarget(null);
  };
  const onCloseAssetsDialog = (assetUrl) => {
    setAssetsTarget(null);
  };
  const handleChangetype = (event) => {
    setTournament((prevState) => ({
      ...prevState,
      tournament_type: event.target.value,
    }));
  };

  const ImageGrid = ({ field, lang }) => (
    <Grid item xs={3}>
      <Box>Prize Banner {lang}</Box>
      {tournament[field] ? (
        <>
          <img
            style={{
              margin: "0 auto",
              width: 100,
              background: "grey",
            }}
            alt="Remy Sharp"
            src={tournament[field]}
          />
          <Iconify
            icon="eva:edit-outline"
            sx={{ width: 20, height: 20, cursor: "pointer" }}
            onClick={() => setAssetsTarget(field)}
          />
        </>
      ) : (
        <Iconify
          icon="eva:plus-circle-outline"
          sx={{
            width: 20,
            height: 20,
            cursor: "pointer",
            marginTop: 2,
            marginBottom: 2,
          }}
          onClick={() => setAssetsTarget(field)}
        />
      )}
    </Grid>
  );
  return (
    <>
      {assetsTarget === null ? (
        <Dialog
          open={props.open}
          onClose={() => {}}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            Create League Tournament
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id="title"
                  label="Title"
                  fullWidth
                  value={tournament.title}
                  variant="standard"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DateTimePicker
                    label="Start UTC"
                    value={tournamentStart}
                    onChange={handleTournamentStartChange}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DateTimePicker
                    label="End UTC"
                    value={tournamentEnd}
                    onChange={handleTournamentEndChange}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tournament.is_visible ?? false}
                      onChange={handleChangeIsVisible}
                      id="is_visible"
                    />
                  }
                  label="Is Visible"
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel id="type-select-label">Type</InputLabel>
                  <Select
                    labelId="type-label"
                    id="type-select"
                    value={tournament.tournament_type ?? "WEEK"}
                    label="Type"
                    onChange={handleChangetype}
                  >
                    <MenuItem value="WEEK">WEEK</MenuItem>
                    <MenuItem value="MONTH">MONTH</MenuItem>
                    <MenuItem value="SEASON">SEASON</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <ImageGrid field={"prize_image_en"} lang={"EN"} />
              <ImageGrid field={"prize_image_fr"} lang={"FR"} />
              <ImageGrid field={"prize_image_sl"} lang={"SL"} />
              <ImageGrid field={"prize_image_es"} lang={"EST"} />
              <ImageGrid field={"prize_image_lv"} lang={"LV"} />
              <ImageGrid field={"prize_image_lt"} lang={"LT"} />
              <ImageGrid field={"prize_image_rus"} lang={"RUS"} />
              <ImageGrid field={"prize_image_esp"} lang={"ESP"} />
              <ImageGrid field={"prize_image_de"} lang={"DE"} />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => onCancel()}>Cancel</Button>
            <Button
              onClick={() => onSuccess()}
              autoFocus
              disabled={
                !tournament.title ||
                !tournament.start_time ||
                !tournament.end_time ||
                !tournament.prize_image_en
              }
            >
              {props.tournament === null ? "Create" : "Edit"}
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <AssetsDialog onSuccess={onChoseAsset} onClose={onCloseAssetsDialog} />
      )}
    </>
  );
}
